import { DELETE_FILE } from "../../actionTypes/actionsTypes";
import { AppAction, BaseAsyncReducerState } from "../../types";

export interface DeleteFileState extends BaseAsyncReducerState {
    deleted: boolean
}

const initialState: DeleteFileState = {
    loading: false,
    error: false,
    success: false,
    deleted: false
}

function deleteFileReducer(state = initialState, action: AppAction) {
    const { payload } = action;
    switch (action.type) {
        case DELETE_FILE.PENDING:
            {
                return {
                    ...state,
                    loading: true,
                    error: false,
                    success: false,
                    s3url: "",
                    pdf: "",
                    message: "",
                }
            }
        case DELETE_FILE.SUCCESS:
            {
                return {
                    ...state,
                    ...payload,
                    loading: false,
                    error: false,
                    success: true,
                }
            }
        case DELETE_FILE.ERROR:
            return {
                ...state,
                ...payload,
                loading: false,
                error: true,
                success: false,
            }
        default:
            return state
    }
}

export default deleteFileReducer;